import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import Button from 'flarum/common/components/Button';
import KeyMetadataModal from './components/KeyMetadataModal';
import { hasKeysTag } from './utils/keysTag';
export default function addKeyMetadataControl() {
  // Mirrors champis-events' addEventControl.js - a button in the
  // discussion's controls dropdown. Shown only when the discussion has the
  // keys tag AND the actor is allowed to touch its metadata (its author, or
  // anyone with the `discussion.rename` permission - computed server-side
  // as canEditKeyMetadata, see extend.php).
  extend(DiscussionControls, 'userControls', function (items, discussion) {
    if (!app.session.user) return;
    if (!hasKeysTag(discussion.tags ? discussion.tags() : [])) return;
    if (!discussion.canEditKeyMetadata()) return;
    items.add('keyMetadata', m(Button, {
      icon: "fas fa-info-circle",
      onclick: () => app.modal.show(KeyMetadataModal, {
        discussion,
        onsubmit: keyMetadata => discussion.save({
          keyMetadata
        })
      })
    }, app.translator.trans('champis-keys.forum.key_metadata.control_button')));
  });
}